<template>
  <div>
    <v-row>
      <v-col
        cols="7"
        class="flex-grow-1 flex-shrink-0 align-center pl-10 pr-10"
      >
        <v-row dense flex class="mt-16 flex-grow-1">
          <v-col
            v-for="item in items"
            :key="item.ID_item"
            cols="3"
            v-if="items"
            class="d-flex justify-space-around"
          >
            <v-card outlined hover width="300px" @click="selectItem(item)">
              <v-sheet class="pa-2 pb-5 justify-center">
                <!-- <v-alert outlined color="red darken-2"> -->
                <v-img :src="item.src" contain height="200px" aspect-ratio="1">
                </v-img>
                <h3>{{ item.sous_categorie }}</h3>
              </v-sheet>
            </v-card>
          </v-col>
        </v-row>
        <v-divider vertical></v-divider>
      </v-col>

      <v-col cols="5">
        <v-card color="#d7fcdb" style="position: sticky">
          <v-row dense flex class="mt-16 flex-grow-1">
            <v-col
              v-for="item in itemSelection"
              :key="item.ID_item"
              cols="4"
              v-if="items"
              class="d-flex justify-space-around"
            >
              <v-card outlined hover width="300px" class="ma-3">
                <v-row>
                  <v-spacer />
                  <v-fab-transition right>
                    <v-btn
                      color="red"
                      fab
                      dark
                      top
                      right
                      small
                      @click="deselectItem(item.ID_item)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-fab-transition>
                </v-row>
                <!-- </v-card-actions> -->
                <v-sheet class="pa-2 pb-5 justify-center">
                  <!-- <v-alert outlined color="red darken-2"> -->

                  <v-img
                    :src="item.src"
                    contain
                    height="200px"
                    aspect-ratio="1"
                  >
                  </v-img>
                  <h5>{{ item.sous_categorie }}</h5>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {},
  methods: {
    selectItem: function (item) {
      console.log(item);
      this.itemSelection.push(item);
    },
    deselectItem: function (item_ID) {
      console.log(item_ID);
      this.itemSelection = this.itemSelection.filter(
        (obj) => obj.ID_item !== item_ID
      );
    },
    fetchClean: function () {
      this.$api
        .post(
          this.$store.state.pathDepth +
            // "../../dash_dependencies/sessions_check.php",
            "sessions_check.php",
          {}
        )
        .then((response) => {
          this.$api
            .post(
              this.$store.state.pathDepth +
                // "../../dash_dependencies/queries/buying_query.php",
                "newsletter_query.php",
              response.data["ID"]
            )
            .then((response) => {
              this.items = response.data;
              this.items.forEach((e) => {
                // fix the link to the item
                e.itemUrl = "/item_page.php?r=inlim&id=" + e.ID_item;
                // fix the link for the img
                if ((e.depot == "1") & (e.categorie != "special")) {
                  e.src = "/photos/defaultPics/" + e.sous_categorie + ".png";
                } else {
                  e.src =
                    "/photos/inlim/" + e.ID_item + "/" + e.ID_item + "_1.jpg";
                }
              });
            });
        });
    },
  },
  created: function () {
    this.fetchClean();
    console.log(this.items);
  },

  data() {
    return { items: null, itemSelection: [] };
  },
};
</script>
